<template>
    <div class="__l">
        <h1 class="title">IP List</h1>
        <input type="text" v-model="$root.persist.ipSearch" class="form-field py-4 px-6" ref="searchbar"
               placeholder="Search for Publications or IP" @keyup.enter="handleSearch">
        <div v-if="results.data && $root.persist.ipSearch">
            <p>The total number of results for <strong>"{{ $root.persist.ipSearch }}"</strong> is
                <strong>{{ results.total }}</strong></p>
        </div>
        <div v-if="results.data && !$root.persist.ipSearch">
            <p>The total number of IP pending for review is <strong>{{ results.total }}</strong></p>
        </div>
        <div class="results-list">
            <div class="results-row">
                <div class="results-head" data-width="40%">Publication</div>
                <div class="results-head" data-width="20%">IP</div>
                <div class="results-head" data-width="20%">Status</div>
                <div class="results-head" data-width="20%">Created</div>
            </div>
            <template v-if="results.data">
                <div class="results-row" v-for="(result, index) in results.data" :key="index"
                     @click="handleSelectIp(result)">
                    <div class="results-cell" data-width="40%">{{ result.publication.title }}</div>
                    <div class="results-cell" data-width="20%">{{ result.ip }}</div>
                    <div class="results-cell" data-width="20%">{{ result.status }}</div>
                    <div class="results-cell" data-width="20%">{{ result.created_at }}</div>
                </div>
                <pagination v-model="page" :records="results.total" :per-page="25" @paginate="loadData"></pagination>
            </template>
            <div class="results-row" v-if="!results.data">
                <div class="results-span text-center" data-width="100%">
                    <p>No results found</p>
                </div>
            </div>
        </div>
        <router-view v-slot="{ Component }">
            <transition name="drop-in" mode="in-out">
                <component :is="Component"></component>
            </transition>
        </router-view>
    </div>
</template>

<script>
import Pagination from 'v-pagination-3'

export default {
    name: 'publicationsIpList',
    data() {
        return {
            results: {},
            page: 1,
        }
    },
    components: {
        Pagination
    },
    mounted() {
        this.setMetaTitle('Publications IP Review | JournoLink Control')
        this.loadData()
    },
    methods: {
        handleSearch() {
            this.loadData()
        },
        /**
         * Load the results from the data provider
         *
         * @return {void}
         */
        loadData() {
            axios.get(route('publications.ip.list'), {
                params: {
                    term: this.$root.persist.ipSearch,
                    page: this.page,
                },
            })
                .then(response => {
                    this.results = response.data.results
                })
                .catch(e => {
                    console.error({e})
                    this.$bus.$emit('alert.danger', 'There was an error retrieving publications')
                })
        },
        /**
         * Handle the selection of a publication IP
         *
         * @param  {Object} publication
         * @return {void}
         */
        handleSelectIp(publicationIp) {
            this.$router.push({
                name: 'publications.ip.show', params: {
                    publicationIpId: publicationIp.id
                }
            })
        },
    },
    beforeRouteUpdate(to, from, next) {
        if (to && to.name === 'publications.ip.list') {
            this.setMetaTitle('List Publications | JournoLink Control')
            this.loadData()
        }

        next()
    },
}
</script>

<style lang="less">
</style>
